import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useCallback } from 'react';
import { pickBy } from 'lodash';
import { useIoContext, useStoreStatic } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import i18next from '~/i18n';
import { selectors } from '~/store/state-selectors';
export function useLogBIEvent() {
    const { logBIEvent, getNow } = useIoContext();
    const { getState } = useStoreStatic();
    const { heapTrack } = useEventReporter();
    return useCallback((biEvent)=>{
        const state = getState();
        const business_type = selectors.user.isVendor(state) ? 'service_provider' : selectors.user.isClient(state) ? 'client' : 'unknown';
        const enrichedEvent = _object_spread({
            client_timestamp: getNow().toISOString(),
            user_id: selectors.user.id(state),
            business_id: selectors.user.businessId(state),
            business_type,
            language: i18next.language,
            ff: pickBy(selectors.ff.featureFlagsData(state))
        }, biEvent);
        logBIEvent(enrichedEvent);
        const { ff: _omitFf } = enrichedEvent, heapPayload = _object_without_properties(enrichedEvent, [
            "ff"
        ]);
        heapTrack(biEvent.type, heapPayload);
    }, []);
}
